"use client";
import Header from "@/components/c-header";
import { Page } from "@/components/ui/page";
import React, { useEffect} from "react";
import ProductShowcaseCard from "@/components/card/c-product-showcase-card";
import useMeasure from "react-use-measure";
import { animate, useMotionValue, motion as m } from "framer-motion";
import useAuth from "@/lib/utils/supabase/client";
import OneTapComponent from "@/components/c-google-onetap";
import LoginCard from "@/components/card/c-login-card";

const LoginPage = () => {
  // --------------------------------- CONST --------------------------------- //

  // --------------------------------- HOOKS --------------------------------- //

  let [ref, { width }] = useMeasure();
  const xTranslationRight = useMotionValue(0);
  const xTranslationLeft = useMotionValue(0);

  const auth = useAuth();

  // --------------------------------- FUNCTIONS --------------------------------- //

  const getOutfits = (
    itemType: "accessory" | "bottom" | "shoe" | "top"
  ): string[] => {
    let outfitItemsArray = [];
    for (let i = 1; i <= 20; i++) {
      outfitItemsArray.push(`/assets/outfits/outfit-${i}/${itemType}.png`);
    }
    return outfitItemsArray;
  };

  // --------------------------------- USE EFFECT --------------------------------- //
  useEffect(() => {
    let controlsRight;
    let controlsLeft;
    let finalPos = -width / 2 - 10;

    controlsRight = animate(xTranslationRight, [0, finalPos], {
      ease: "linear",
      duration: 100,
      repeat: Infinity,
      repeatType: "loop",
      repeatDelay: 0,
    });

    controlsLeft = animate(xTranslationLeft, [finalPos, 0], {
      ease: "linear",
      duration: 100,
      repeat: Infinity,
      repeatType: "loop",
      repeatDelay: 0,
    });

    return () => {
      controlsRight.stop();
      controlsLeft.stop();
    };
  }, [xTranslationRight, xTranslationLeft, width]);

  return (
    <Page
      className=" relative overflow-x-hidden px-4 md:py-0 pb-4  "
      size={"full"}
    >
      <OneTapComponent />
      {/* <LoggingInModal open={isLoggingIn} /> */}
      <Header {...auth} className=" max-w-screen-base mx-auto " />

      <div className=" absolute top-0 left-0 w-full md:max-w-[56rem] max-w-[18rem] h-96 bg-white blur-[50px] rounded-br-[20rem] -z-10" />
      <div className=" flex flex-col absolute overflow-hidden top-[4.1rem] md:top-[14.5rem] gap-y-[1.25rem] -z-20 w-full left-1/2 pt-[1.25rem] -translate-x-1/2 max-w-[1680px] ">
        <div className=" absolute left-0 h-full w-30 bg-gradient-to-r from-white to-transparent z-10" />
        <div className=" absolute right-0 h-full w-30 bg-gradient-to-l from-white to-transparent z-10" />
        <div className=" absolute bottom-0 w-full h-30 bg-gradient-to-t from-white to-transparent z-10" />
        <m.div
          style={{ x: xTranslationRight }}
          ref={ref}
          className=" flex gap-[1.25rem] w-max will-change-transform"
        >
          {[...getOutfits("accessory"), ...getOutfits("accessory")].map(
            (image, index) => (
              <ProductShowcaseCard key={index} imagePath={image} />
            )
          )}
        </m.div>
        <m.div
          style={{ x: xTranslationLeft }}
          ref={ref}
          className=" flex gap-[1.25rem] w-max will-change-transform"
        >
          {[...getOutfits("top"), ...getOutfits("top")].map((image, index) => (
            <ProductShowcaseCard key={index} imagePath={image} />
          ))}
        </m.div>
        <m.div
          style={{ x: xTranslationRight }}
          ref={ref}
          className=" flex gap-[1.25rem] w-max will-change-transform"
        >
          {[...getOutfits("bottom"), ...getOutfits("bottom")].map(
            (image, index) => (
              <ProductShowcaseCard key={index} imagePath={image} />
            )
          )}
        </m.div>
        <m.div
          style={{ x: xTranslationLeft }}
          ref={ref}
          className=" flex gap-[1.25rem] w-max will-change-transform"
        >
          {[...getOutfits("shoe"), ...getOutfits("shoe")].map(
            (image, index) => (
              <ProductShowcaseCard key={index} imagePath={image} />
            )
          )}
        </m.div>
      </div>

      {/* Intro Text Container */}
      <div className=" max-w-screen-base mx-auto md:pt-[1.18rem] md:flex-col">
        <h1 className=" font-bai-jamjuree md:text-title font-medium md:leading-sm text-left text-title-mobile leading-md  ">
          Your AI-Powered Fashion Stylist
        </h1>
        <h2 className=" md:text-heading md:leading-sm text-left md:mt-4 mt-5 font-normal text-heading-mobile leading-[1.44] ">
          Discover your perfect outfit in seconds, curated for any occasion.
        </h2>
        <div className=" max-w-[30rem] h-[30rem]  bg-white border border-lewk-grey rounded-base shadow-container mt-8 gap-4 flex flex-col p-4 md:p-10 ">
          <LoginCard />
        </div>
      </div>
    </Page>
  );
};

export default LoginPage;
